export default __webpack_public_path__ + "static/media/January2022.32bd9a8b.png";